import ApiServer from "../ApiServer.js";
import * as libLocation from "../lib/location.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import * as forms from "../util/forms.js";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as Html from "../util/Html.ts";
import {transform} from "../handlebars_family.js";

var inviteModal;

ApiServer["custom.invite"] = function(form){
  form = $(form);
  var
    email = form.find("input[name='email'],input[name='phone']");
  
  ApiServer.famsendinvite.prepare({
    role:"Unknown",
    deviceComposerUsed:false
  })(form,
    async function(){
      amplify.publish('familyChange')
      modal.closeModal(inviteModal);
      var [refreshed,tpl] = await Promise.all([libLocation.refresh(),import("../modal/invite_done.mustache")])
      modal.openModal(tpl); 
    },
    function(err){
      if(err.code==='17'){
        forms.markInvalid(email,i18n.get("invitationJs.errorEmail"));
      }else if(err.code==='19'){
        forms.markInvalid(email,i18n.get("invitationJs.errorAlreadyInvited"));
      }else if(err.code==='12'){
        forms.markInvalid(email,i18n.get("invitationJs.errorAlreadyInFamily"));
      }else if(err.code==='-23006'){
        forms.markInvalid(email,i18n.get("invitationJs.-23006"));
      }else if(err.code==='505'){
        //quota reached KO_LIMIT
        modal.closeModal(inviteModal);
      }else{
        forms.markInvalid(email,i18n.get("fw2.defaultError"));
      }
    }
  )
}  
ApiServer["custom.invitenoemailstep1"] = function(form){
  form = $(form);
  var datas = {
      firstname : form.find("input[name='firstname']").val(),
      birthday : form.find("input[name='birthday']").dateValue()||null,
      picture : form.find("input[name='picture']").get(0).files[0],
      role:'Unknown'
  };
  
  import("../modal/invite_noemail2.mustache").then(function(tpl){
    modal.closeModal(inviteModal);
    inviteModal = modal.openModal(tpl,datas);
  });  
  ApiServer["custom.invitenoemailstep2"] = function(form){
    form = $(form);
    var 
      identifierInput = $(form.find("input").get(0)),
      passwordInput = $(form.find("input").get(1));
      
    datas.identifier = identifierInput.val();
    datas.password = passwordInput.val();
    
    if(datas.identifier.indexOf('@')>-1){
      forms.markInvalid(identifierInput,"Email rejeted")
      return;
    }
    
    ApiServer.accinvite(datas,async function(){
      amplify.publish('familyChange')
      var [refreshed,tpl] = await Promise.all([libLocation.refresh(),import("../modal/invite_noemaildone.mustache")])
      modal.openModal(tpl,datas);
        
    },function(err){
      if(err.code==="2"){
        forms.markInvalid(identifierInput,i18n.get("errors.identifierUnavaible"));
      }else if(err.code==='21'){
        forms.markInvalid(identifierInput,i18n.get("errors.identifierInvalid"));
      }else{
        throw err;
      }
    });
  }
}
  


Html.register({
  "invite":function(){
    import("../modal/invite_member.mustache").then(function(tpl){
      modal.closeModal();
      inviteModal = modal.openModal(tpl,{editable:true});
      
    });  
  },
  "invitenoemail":function(){
    import("../modal/invite_noemail.mustache").then(function(tpl){
      modal.closeModal(inviteModal);
      inviteModal = modal.openModal(tpl,{editable:true});
    });
  },
  
  "invitemenu":function(){
    import("../modal/invite_menu.mustache").then(function(tpl){
      modal.openModal(tpl);
    });
    return false;
  },
  "invitelink":function(){
    ApiServer.famgetinvitationlinkbean(function(bean){
      //TODO remove next line in 2020
      bean.endDate = bean.expirationDate;
      import("../modal/dialog_share.mustache").then(function(TPL){
        modal.closeModal();
        modal.openModal(TPL,{title: 'invite_link.title',message:transform(i18n.get('invite_link.text'),bean),link:bean.link,pictureUrl:FwDatas.getFamily().coverUri});
      })
    });
  }
  
});